import { TextField } from '@flos/react-ui';
import useAppState from '../../../state/appState';
import HouseAddress, { AddressOption, houseAddressKeys } from './HouseAddress';
import { getTempElementId } from './getTempElementId';
import { getDefaultAddresses } from './getDefaultAddresses';
import { useState } from 'react';

const ADDRESS_ID: houseAddressKeys = 'showOtherAddressForeign';

export const OtherAddressForeign = ({
    elementId,
    isRequired,
    setFormValue
}: {
    elementId: string;
    isRequired: boolean;
    setFormValue: (key: string, value: AddressOption) => void;
}) => {
    const formValues = useAppState((state) => state.formValues);
    const value = HouseAddress.getValueOrDefault(formValues, elementId);
    const defaultAddress = getDefaultAddresses(ADDRESS_ID);
    const [fieldHasHadFocusAtLeastOnce, setFieldHasHadFocusAtLeastOnce] = useState(false);
    return (
        <TextField
            value={value.valueOnSubmit.description}
            label="Adresse udenfor Danmark"
            required={isRequired}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const value = event.target.value;
                const valueObject = {
                    ...defaultAddress,
                    valueOnSubmit: {
                        ...defaultAddress.valueOnSubmit,
                        description: value
                    }
                };

                setFormValue(elementId, valueObject);

                // Store for when the user clicks
                // on of his policyAddresses (that then overwrite the value from the State)
                // and then clicks back to 'Other address'
                setFormValue(getTempElementId(elementId, ADDRESS_ID), valueObject);
            }}
            onBlur={() => {
                setFieldHasHadFocusAtLeastOnce(true);
            }}
            isValid={HouseAddress.isFieldValid(fieldHasHadFocusAtLeastOnce, formValues, elementId)}
            errorText="Adresse skal udfyldes"
        />
    );
};
